import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    
    getAlGroupsForDropdown,
    getOperationEntityByGroup,
    createQRtag,
    saveQRtags,
    getAllRoutesByFactoryID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationEntityByGroup(groupID){
    var operationEntityArray = [];
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID','groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function createQRtag(data){
   var qrtags = {
        groupID : parseInt(data.groupID),
        operationEntityID : parseInt(data.operationEntityID),
        collectionPointID : parseInt(data.routeID),
        noOfCodes : parseInt(data.noOfCodes),
        createdBy: 0,
     }
     const response = await CommonPost('/api/QRtag/CreateQRtag', null, qrtags);
     return response.data;
}

async function saveQRtags(data){
    const response = await CommonPost('/api/QRtag/SaveQRtag',null,data);
    return response
}
